export const SIGNUP_MODAL_FLAG_KEY = 'signup_modal_contextualized'

// Auth-app API route that feeds the dedicated signup-modal Prometheus health
// counters from the client. Client-safe (no server imports) so the header can
// build the beacon URL without pulling the handler's prom-client deps into the
// browser bundle.
export const SIGNUP_MODAL_METRICS_API_ROUTE = '/api/metrics/signup-modal'

export const SIGNUP_MODAL_VARIANTS = [
  'control',
  'a_cta_echo',
  'b_continuation_in_title',
  'c_curiosity_gap',
  'd_direct_value',
  'e_platform_benefits',
] as const

export type SignupModalVariant = (typeof SIGNUP_MODAL_VARIANTS)[number]

export function isSignupModalVariant(value: unknown): value is SignupModalVariant {
  return typeof value === 'string' && (SIGNUP_MODAL_VARIANTS as readonly string[]).includes(value)
}

export const SIGNUP_MODAL_FLAGS = {
  [SIGNUP_MODAL_FLAG_KEY]: 'control' as SignupModalVariant,
}

export type SignupModalFlags = typeof SIGNUP_MODAL_FLAGS
